import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import FooterLinks from '../../../components/template/FooterLinks';
import './esqueciSenha.css';

const EsqueciSenha = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleOptionChange = (event) => {
    const tentativas = [0];
    if (event.target.value === 'PF') navigate('/esqueciMinhaSenhaPF');
    else navigate('/esqueciMinhaSenhaPJ');
  };

  return (
    <>
      <div className="conteudo">
        <div id="recuperar-senha" className="card bg-superficie elev5">
          <img
            alt={t('cadastro.accessibility.carol_image')}
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />
          <h1>{t('cadastro.titles.forgot_password')}</h1>
          <h5>{t('cadastro.titles.select_profile')}</h5>

          <div className="btns-row">
            <button className="btn-pre" onClick={handleOptionChange} value="PF">
              <i className="ic-usuario"></i>
              {t('cadastro.forms.options.individual')}
            </button>
            <button
              className="btn-cont"
              onClick={handleOptionChange}
              value="PJ"
            >
              <i className="ic-empresa"></i>
              {t('cadastro.forms.options.business')}
            </button>
          </div>

          <button className="btn-txt voltar" onClick={() => navigate('/login')}>
            {t('cadastro.forms.buttons.back')}
          </button>
        </div>
      </div>

      <FooterLinks />
    </>
  );
};
export default EsqueciSenha;
